import { render, staticRenderFns } from "./risk-information.vue?vue&type=template&id=436f182b&scoped=true"
import script from "./risk-information.vue?vue&type=script&lang=js"
export * from "./risk-information.vue?vue&type=script&lang=js"
import style0 from "./risk-information.vue?vue&type=style&index=0&id=436f182b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436f182b",
  null
  
)

export default component.exports